export default function formatAirDate(dateString) {
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const ptDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
  );
  const etDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'America/New_York' })
  );
  const ptTime = `${ptDate.toLocaleTimeString('en-US', { hour: 'numeric' })}`;
  const etTime = `${etDate.toLocaleTimeString('en-US', { hour: 'numeric' })}`;
  const formattedTime = `${ptTime} PT / ${etTime} ET`;

  return {
    date: formattedDate,
    time: formattedTime,
  };
}
